import { render, staticRenderFns } from "./AddFile.vue?vue&type=template&id=15239856"
import script from "./AddFile.vue?vue&type=script&lang=js"
export * from "./AddFile.vue?vue&type=script&lang=js"
import style0 from "./AddFile.vue?vue&type=style&index=0&id=15239856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports